// extracted by mini-css-extract-plugin
export default {"resetButton":"wlJw6V2","append":"OFzY81i"};